// src/loggerService.js
import { Bugfender } from "@bugfender/sdk";

/**
 * Debug-level events (technical details, network info, performance).
 * For demonstration, we send these to console + Sentry.
 */
export function trackDebugEvent(eventName, data = {}) {
  Bugfender.log("DEBUG", `[DEBUG] ${eventName}`, data);
  // console.log(`[DEBUG] ${eventName}`, data);
}

/**
 * Analytics-level events (user metrics, usage analytics, business logic).
 * For demonstration, we simply log to console, but you can integrate
 * services like Google Analytics, Mixpanel, Segment, etc.
 */
export function trackAnalyticsEvent(eventName, data = {}) {
  // console.log(`[ANALYTICS] ${eventName}`, data);
  // e.g.: window.analytics.track(eventName, data);
}
